// client/src/components/ClientNavbar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaChartBar, FaHome, FaUser, FaCamera, FaTags } from 'react-icons/fa';
import { SidebarBrand } from '../shared/BrandLogo';
import '../CSS/Navbar.css';

const ClientNavbar = () => {
  return (
    <div className="sidebar-container">
      <SidebarBrand label="Espace client" />
      <div className="sidebar-item">
        <NavLink
          to="/clientdocs"
          end
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaHome size={20} />
          <span>Accueil</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/clientpromo"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaTags size={20} />
          <span>Offres</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/clientcamera"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaCamera size={20} />
          <span>Caméra</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/client-dashboard"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaChartBar size={20} />
          <span>Statistiques</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/clientsettings"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUser size={20} />
          <span>Profil</span>
        </NavLink>
      </div>
    </div>
  );
};

export default ClientNavbar;
